import "../../assets/css/clientAlerts/clientAlerts.css"

import { useEffect, useState } from "react"
import { Tab, Tabs } from "react-bootstrap"

import SecurityStaffList from "./securityStaffList"
import VisitsList from "./visitsList"

export default function SecurityStaff({ darkLightMode }) {
    const [searchText, setSearchText] = useState("");

    const [key, setKey] = useState(0)

    // RESET THE SEARCH EVERY TIME A TAB IS CHANGED
    useEffect(() => {
        clearSearchFilter()
        setSearchText("")
    }, [key])

    // FUNCTION TO CLEAR THE SEARCH INPUT
    const clearSearchFilter = () => {
        const searchElement = document.getElementById("generalSearch")
        searchElement.value = ""
    }

    return (
        <section className={`alerts ${darkLightMode ? "darkMode" : null}`}>
            <div className="titleAndSearch">
                <h3 className="title">Security</h3>
                <div className="searchAndSort">
                    <div className={`searchContainer ${darkLightMode ? "darkMode" : null}`}>
                        <input
                            id="generalSearch"
                            type="text"
                            placeholder="Search by name..."
                            onChange={(e) => {
                                const searchValue = e.target.value;
                                setSearchText(searchValue);
                            }}
                        />
                    </div>
                </div>
            </div>

            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(+k)}>

                <Tab eventKey={0} title="Guards">
                    <SecurityStaffList
                        searchText={searchText}
                        darkLightMode={darkLightMode}
                    />
                </Tab>
                <Tab eventKey={1} title="Visits">
                    <VisitsList
                        searchText={searchText}
                        darkLightMode={darkLightMode}
                    />
                </Tab>
            </Tabs>
        </section>
    )
}